export function fetchUsers(UsersResource) {
  return function (dispatch) {
    return UsersResource.getList().then((users) => {
      return dispatch({type: 'USERS_FETCH_SUCCESS', users});
    });
  };
}


/** WEBPACK FOOTER **
 ** ./src/actions/users-actions.js
 **/